// SignupConfirmation.js
export default function SignUpConfirmation() {
    return (
      <div style={{ textAlign: "center", marginTop: "10rem" }}>
        <h1>Success!</h1>
        <p>Your account has been created.</p>
        <p>You can now close this tab and proceed with onboarding.</p>
      </div>
    );
  }
  